import OperationalReportPage from './OperationalReportPage';
export default function CatalogueExceptionsReportPage(){return <OperationalReportPage kind="catalogue-exceptions"/>;}
